import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import CalendarMainLayer from "../components/CalendarMainLayer";
 
 
const CalendarMainPage = () => {
  return (
    <>
      
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Timetable  </h5><Breadcrumb title="Timetable" /></div>
 
        {/* CalendarMainLayer */}
        <CalendarMainLayer />
 
 
    </>
  );
};
 
export default CalendarMainPage;
 
 